module.exports = "https://www.gc-qa.gnp.com.mx/c0cabe7111240db4626c867f73e26672.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-gnp.gif
// module id = 8150
// module chunks = 0